import Request from "@/services/api/Request";

import { API_URL } from "@/constants";

export const routes = {
  playlists: `${API_URL}/playlists`,
  playlist: id => `${API_URL}/playlists/${id}/show`,
  create: `${API_URL}/playlists`,
  remove: id => `${API_URL}/playlists/${id}`,
  update: id => `${API_URL}/playlists/${id}`,
  addTracks: id => `${API_URL}/playlists/${id}/tracks`,
  removeTrack: (id, trackId) => `${API_URL}/playlists/${id}/tracks/${trackId}`,
  cover: id => `${API_URL}/playlists/${id}/image`
};

export const request = new Request("playlists");

export default {
  fetch(type = "", params = {}) {
    switch (type) {
      case "playlist":
        return this.one(params);
      default:
        return request.get(routes.playlists, params);
    }
  },
  one(params) {
    return request.get(routes.playlist(params.id));
  },
  create(params) {
    return request.post(routes.create, params);
  },
  remove(params) {
    const id = params.id;
    delete params.id;
    return request.delete(routes.remove(id), params);
  },
  update(params) {
    const id = params.id;
    delete params.id;
    return request.post(routes.update(id), params);
  },
  addTracks(params) {
    const id = params.id;
    delete params.id;
    return request.post(routes.addTracks(id), params);
  },
  removeTrack(params) {
    const id = params.id;
    const trackId = params.trackId;
    delete params.id;
    delete params.trackId;
    return request.delete(routes.removeTrack(id, trackId), params);
  },
  cover(params) {
    const { id, image } = params;
    const formData = new FormData();

    formData.append("image", image);

    return request.post(routes.cover(id), formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }
};
